import React, { useState, useEffect, useContext } from "react";
import "./My_Wallet.css";
import { Nav, Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import Add_Money from "./add_money/Add_Money";
import OrderCard from "../my_orders/order_card/OrderCard";
import { Context } from "../../../../../utils/context";
import { getData } from "../../../../../utils/api";

const My_Wallet = () => {
  const { IMG_URL } = useContext(Context);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchTransactions = async (page = 1) => {
    setLoading(true);
    try {
      const res = await getData(`/wallet/get-history?page=${page}&per_page=10`);
      if (res?.success) {
        setTransactions(res.data.data || []);
        setTotalPages(res.data.totalPages || 1);
        setCurrentPage(res.data.currentPage || 1);
      }
    } catch (err) {
      console.error("Failed to fetch wallet history", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions(currentPage);
  }, [currentPage]);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <section className="My_Wallet">
      <div className="container">
        {/* <Common_Back_Header backNavigation="/my-profile" /> */}

        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
          <div className="tabs_holder">
            <Nav variant="pills" className="">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <span className="tab_text">Add Money</span>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="second">
                  <span className="tab_text">Wallet Transactions</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <div className="">
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Add_Money />
                </Tab.Pane>

                <Tab.Pane eventKey="second">
                  {loading ? (
                    <div className="text-center py-5">
                      Loading transactions...
                    </div>
                  ) : transactions.length === 0 ? (
                    <div className="text-center py-5">No transactions yet</div>
                  ) : (
                    transactions.map((tx) => (
                      <OrderCard
                        key={tx.id}
                        // navigate="/order-details" // optional - can remove if not needed
                        title="Wallet Transaction"
                        footer_text_color={
                          tx.type === "Credit" ? "#007C08" : "#d32f2f"
                        }
                        img="/assets/images/profile/myaccount/img1.png"
                        orderId={tx.orders_detail?.invoice_number} // ← Only "Payment ID: ..."
                        items={1} // Amount with ₹
                        kwd={Number(tx.amount).toFixed(2)} // "Credit" or "Debit" (no ₹)
                        date={formatDate(tx.createdAt)}
                        showViewDetails={true}
                        data={tx}
                        type={true}
                      />
                    ))
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    </section>
  );
};

export default My_Wallet;
